import { useEffect, useState } from "react";

import { useNavigationHooks } from "hooks/shared-hooks/use-navigation-hooks";
import { useQuickViewQueriesSelect } from "store";
import { QuickViewQueries } from "store/types";

interface IUseQuickViewQueries {
  listen: () => void;
  isQueriesEmpty: (data: QuickViewQueries) => boolean;
}

const isQueriesEmpty = (data: QuickViewQueries): boolean => {
  if (Object.keys(data.filters).length) return false;

  // visibleSystemColumns excluded: always restored from server (deal-quick-view/settings)
  const { visibleSystemColumns: _s, ...columnsToCheck } = data.columns;
  const hasUserColumns = Object.values(columnsToCheck).some((arr) => arr.length);
  if (hasUserColumns) return false;

  // return data.groupByDeal === defaultQuickViewQueries.groupByDeal; //not supporting groupByDeal anymore
  return true;
};

export const useQuickViewQueries = (): IUseQuickViewQueries => {
  const [listen, setListen] = useState<boolean>(false);

  const queries = useQuickViewQueriesSelect();
  const { setParams, removeParams } = useNavigationHooks();

  useEffect(() => {
    if (!listen) return;
    if (isQueriesEmpty(queries)) {
      removeParams(["quickViewQueries"]);
    } else {
      setParams({ search: { quickViewQueries: JSON.stringify(queries) } });
    }
    return () => {
      removeParams(["quickViewQueries"]);
    };
  }, [listen, queries]);

  return {
    listen: () => setListen(true),
    isQueriesEmpty
  };
};
